import React from 'react'

export default ({ ...props }) => (
  <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M14.6251 0H10.8751C10.6681 0 10.5001 0.168 10.5001 0.375C10.5001 0.582 10.6681 0.75 10.8751 0.75H13.7498L5.36034 9.1095C5.21334 9.25575 5.21334 9.49275 5.35959 9.63975C5.43309 9.71325 5.52909 9.75 5.62509 9.75C5.72109 9.75 5.81634 9.71325 5.88984 9.6405L14.2501 1.31025V4.125C14.2501 4.332 14.4181 4.5 14.6251 4.5C14.8321 4.5 15.0001 4.332 15.0001 4.125V0.375C15.0001 0.168 14.8321 0 14.6251 0V0Z'
      fill='black'
    />
    <path
      d='M12.375 15H1.125C0.50475 15 0 14.4952 0 13.875V2.625C0 2.00475 0.50475 1.5 1.125 1.5H8.625C8.832 1.5 9 1.668 9 1.875C9 2.082 8.832 2.25 8.625 2.25H1.125C0.918 2.25 0.75 2.418 0.75 2.625V13.875C0.75 14.082 0.918 14.25 1.125 14.25H12.375C12.582 14.25 12.75 14.082 12.75 13.875V6.375C12.75 6.168 12.918 6 13.125 6C13.332 6 13.5 6.168 13.5 6.375V13.875C13.5 14.4952 12.9952 15 12.375 15Z'
      fill='black'
    />
  </svg>
)
